import { useState } from "react";
import { Loader2, BellRing } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export function SaveSearchDialog({ filters, onClose }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const label = [filters.industry, filters.state, filters.q && `"${filters.q}"`].filter(Boolean).join(" · ") || "All verified businesses";
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/saved-searches", { email, ...filters }); toast.success("Check your inbox to confirm your alert"); onClose(); }
    catch (e2) { toast.error(formatErr(e2)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="save-search-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Email me new matches</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600 -mt-2">Get a daily summary when new businesses matching <b data-testid="save-search-label">{label}</b> are verified. We'll send a confirmation first, and you can unsubscribe anytime.</p>
        <form onSubmit={submit} className="space-y-3">
          <Input required type="email" placeholder="you@lender.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="save-search-email-input" />
          <Button type="submit" disabled={busy} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="save-search-submit-button">{busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <BellRing className="h-4 w-4 mr-2" />}Save search</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
